import { render, staticRenderFns } from "./DashCard.vue?vue&type=template&id=2a3032da&scoped=true"
import script from "./DashCard.vue?vue&type=script&lang=js"
export * from "./DashCard.vue?vue&type=script&lang=js"
import style0 from "./DashCard.vue?vue&type=style&index=0&id=2a3032da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3032da",
  null
  
)

export default component.exports